import { memo } from "react";
import Skeleton from "react-loading-skeleton";
import "./QuotationSkeleton.scss";
import FlightsAndOptionsSkeleton from "app/pages/Booking/Quotation/Skeletons/FlightsAndOptionsSkeleton";
import PropTypes from "prop-types";

const SKELETON_HIGHLIGHT_COLOR = "#cdcdcd";

const QuotationSkeleton = ({ isHotelOnly }) => {
	return (
		<>
			<div className="skeleton-quote">
				<div className="skeleton-quote__head room">
					<Skeleton
						highlightColor={SKELETON_HIGHLIGHT_COLOR}
						height={20}
						width={400}
						containerClassName="skeleton-quote__head-skeleton skeleton"
					/>
				</div>
				<Skeleton
					highlightColor={SKELETON_HIGHLIGHT_COLOR}
					height={20}
					containerClassName="skeleton-section"
				/>
				<div className="skeleton-quote-room__multimedia skeleton-section">
					<div className="skeleton-quote-room__option">
						<div className="skeleton-quote-room__option-checkbox" />
						<Skeleton
							highlightColor={SKELETON_HIGHLIGHT_COLOR}
							baseColor="#DDDDDD"
							height={20}
							containerClassName="skeleton-quote-room__option-skeleton skeleton"
							borderRadius={15}
						/>
					</div>
					<div className="skeleton-quote__file">
						<Skeleton
							highlightColor={SKELETON_HIGHLIGHT_COLOR}
							baseColor="#DDDDDD"
							className="skeleton-quote__file-skeleton"
							width={400}
						/>
					</div>
					<Skeleton
						highlightColor={SKELETON_HIGHLIGHT_COLOR}
						height={20}
						baseColor="#DDDDDD"
						borderRadius={15}
						containerClassName="skeleton-section"
					/>
					<Skeleton
						highlightColor={SKELETON_HIGHLIGHT_COLOR}
						height={20}
						baseColor="#DDDDDD"
						borderRadius={15}
						containerClassName="skeleton-line"
					/>
				</div>
				<Skeleton
					highlightColor={SKELETON_HIGHLIGHT_COLOR}
					height={80}
					borderRadius={10}
					containerClassName="skeleton-section skeleton-quote__block"
				/>
				<Skeleton
					highlightColor={SKELETON_HIGHLIGHT_COLOR}
					height={80}
					borderRadius={10}
					containerClassName="skeleton-section skeleton-quote__block"
				/>
				<br />
				<Skeleton
					highlightColor={SKELETON_HIGHLIGHT_COLOR}
					height={20}
					borderRadius={15}
					containerClassName="skeleton-section skeleton-quote__block"
				/>
				<Skeleton
					highlightColor={SKELETON_HIGHLIGHT_COLOR}
					height={80}
					borderRadius={10}
					containerClassName="skeleton-section skeleton-quote__block"
				/>
				<Skeleton
					highlightColor={SKELETON_HIGHLIGHT_COLOR}
					height={80}
					borderRadius={10}
					containerClassName="skeleton-section skeleton-quote__block"
				/>
				<Skeleton
					highlightColor={SKELETON_HIGHLIGHT_COLOR}
					height={80}
					borderRadius={10}
					containerClassName="skeleton-section skeleton-last skeleton-quote__block"
				/>
			</div>
			{!isHotelOnly && <FlightsAndOptionsSkeleton />}

			{!isHotelOnly && (
				<div className="skeleton-quote">
					<div className="skeleton-quote__head transfer">
						<Skeleton
							highlightColor={SKELETON_HIGHLIGHT_COLOR}
							height={20}
							borderRadius={15}
							width={400}
							containerClassName="skeleton-quote__head-skeleton skeleton"
						/>
					</div>
					<Skeleton
						highlightColor={SKELETON_HIGHLIGHT_COLOR}
						height={80}
						borderRadius={10}
						containerClassName="skeleton-section skeleton-last"
					/>
				</div>
			)}
		</>
	);
};

QuotationSkeleton.propTypes = {
	isHotelOnly: PropTypes.bool,
};

export default memo(QuotationSkeleton);
